import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Layout from "../../shared/components/layout";

const PersonPickerList = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0;
`;

const Input = styled.input`
  margin-right: 10px;
`;

const Controls = styled.div`
  position: fixed;
  width: 80%;
  bottom: 5%;
  left: 10%;
`;

function SelectMember({ members }) {
  const { register, handleSubmit, errors } = useForm();
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const history = useHistory();

  const onNext = () => {
    if (selectedMemberId) {
      const currentQueryParams = window.location.search;
      const updatedParams = `${currentQueryParams}&enterprise_id=${selectedMemberId}`;

      history.push({
        pathname: "/hi2-auth-ui/user-consent",
        search: updatedParams,
      });
      return;
    }
  };

  useEffect(() => {
    if (members.length === 1) {
      setSelectedMemberId(members[0].enterpriseId);
      onNext();
    }
  }, []);

  return (
    <Layout header={"Whose health information do you consent to share?"}>
      <form onSubmit={handleSubmit(onNext)}>
        <PersonPickerList>
          {members.map((member) => (
            <li key={member.enterpriseId}>
              <label
                className="checkbox-container"
                htmlFor={member.enterpriseId}
              >
                <span className="capitalize-text">
                  {member.firstName} {member.lastName}, ({member.role})
                </span>

                <Input
                  id={member.enterpriseId}
                  type="radio"
                  name="enterpriseId"
                  value={member.enterpriseId}
                  ref={register({ required: true })}
                  onChange={() => setSelectedMemberId(member.enterpriseId)}
                  className="cigna-checkbox"
                />
                <span className="radio"></span>
              </label>
            </li>
          ))}
        </PersonPickerList>

        <span className="validation-error-msg">
          {errors.enterpriseId && "Please select a member."}
        </span>

        <Controls>
          <button type="submit" className="btn btn-primary btn-lg bold">
            Next
          </button>
        </Controls>
      </form>
    </Layout>
  );
}

export default SelectMember;
